import styled from 'styled-components';

import { theme } from './GlobalStyles';

const StyledTile = styled.div`
  display: flex;
  border-radius: 0.75rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  max-height: 6.75rem;

  ${theme.mediaQueries.above.small} {
    flex-direction: column;
    height: 100%;
    max-height: none;
  }
`;

const Banner = styled.div`
  flex: 0 0 36.55%;
  img {
    display: block;
    width: 100%;
    height: 100%;
    max-height: 15rem;
    object-fit: cover;
  }
  ${theme.mediaQueries.above.small} {
    flex: 1;
    padding: 0;
  }
`;

const Title = styled.div`
  font-size: 1.0625rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Content = styled.div`
  padding: 1.25rem;
  color: ${theme.colors.black};
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: 0;
  .logo {
    display: ${(props) => (props.partner ? 'block' : 'none')};
    flex: 0 0 auto;
    margin-right: 0.625rem;
    width: 4.75rem;
    height: 4.75rem;
    border-radius: 100%;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.22);
    padding: 0.75rem;
    ${theme.mediaQueries.above.small} {
      display: block;
    }
  }
  ${theme.mediaQueries.above.small} {
    flex-grow: 0;
  }
`;

const Tile = ({ title, banner, logo, partner }) => (
  <StyledTile partner={partner}>
    {!partner && (
      <Banner>
        <img src={banner ? banner : '/static/img/common/placeholder-img.png'} alt={title} />
      </Banner>
    )}
    <Content partner={partner}>
      {partner && (
        <figure className="logo">
          <img src={logo} alt="" />
        </figure>
      )}
      <div
        css={`
          min-width: 0;
        `}
      >
        <Title>{title}</Title>
      </div>
    </Content>
  </StyledTile>
);
export default Tile;
